import { usePlay } from "./PlayerContext"
import { useSetAtom } from "jotai"
import { audioElementRefAtom } from "../state"
import { ClassAttributes, AudioHTMLAttributes } from "react"
import useRadio from "../useRadio"
import { JSX } from "react"

const Audio = (
  props: JSX.IntrinsicAttributes &
    ClassAttributes<HTMLAudioElement> &
    AudioHTMLAttributes<HTMLAudioElement>
) => {
  const { onFinish } = useRadio(usePlay())
  const setRef = useSetAtom(audioElementRefAtom)
  return <audio ref={setRef} onEnded={onFinish} {...props} />
}

export default Audio
